var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { put, call } from 'redux-saga/effects';
import { onVehicleInfoUpdated, onVehicleIdentificationErrorUpdated, onResetVehicleInfo, onVehicleResolved, onVssErrorUpdated } from '../actions';
import { VehicleInfoOperations } from '../services';
import { VehicleIdentificationErrorCode, VehicleSelectionMethod } from '../enums';
export function* genericVehicleLoadSaga(action) {
    const { vehicleInfo, model, year, typeId } = action.payload;
    try {
        const result = yield call(VehicleInfoOperations.handleGenericVehicle, vehicleInfo, model, year, typeId);
        if (result) {
            if (result.ErrorCode || result.Error) {
                const { ErrorCode, Error } = result, restResult = __rest(result, ["ErrorCode", "Error"]);
                yield put(onVssErrorUpdated(Object.assign(Object.assign({}, restResult), { error: Error, errorCode: ErrorCode })));
            }
            else {
                //We are not in an error state, so clear any existing error
                yield put(onVssErrorUpdated({}));
                yield put(onVehicleInfoUpdated(result));
                yield put(onVehicleIdentificationErrorUpdated({ errorCode: VehicleIdentificationErrorCode.Default }));
                if (result.Vehicle && result.Vehicle.Id !== undefined && result.Vehicle.Id !== null) {
                    yield put(onVehicleResolved(result));
                }
            }
        }
    }
    catch (e) {
        yield put(onResetVehicleInfo(VehicleSelectionMethod.GenericVehicle, model));
    }
}
//# sourceMappingURL=genericVehicleLoadSaga.js.map